import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Footer.module.scss';

const ForFreelancers = ({ omitHeading = false }) => {
  return (
    <ul className={styles.linkList}>
      {!omitHeading && (
        <li>
          <a href="/freelancers">For freelancers</a>
        </li>
      )}
      <li>
        <a href="/freelance/creatives">Find creative jobs</a>
      </li>
      <li>
        <a href="/freelance/developers">Find developer jobs</a>
      </li>
      <li>
        <a href="/freelance/marketing">Find marketing jobs</a>
      </li>
      <li>
        <a href="/freelance/music">Find music jobs</a>
      </li>
      <li>
        <a href="/jobs">See all freelance jobs</a>
      </li>
    </ul>
  );
};

ForFreelancers.propTypes = {
  omitHeading: PropTypes.bool,
};

export default ForFreelancers;
